import classNames from 'classnames';
import FieldError from '../FieldError';
import { FieldRecommendation } from './FieldRecommendation/FieldRecommendation';
import { FormHelper } from './FormHelper';

interface FormFeedbackProps {
  error?: string;
  errorId?: string;
  errorCyTag?: string;
  description?: string;
  helperId?: string;
  recommendation?: string;
  recommendationId?: string;
  recommendationCyTag?: string;
  /**
   * Keeps one line of feedback height available even when there is no message.
   * The application default is deliberately false: empty fields should not
   * manufacture blank vertical bands. Opt in only for a fixed-height surface
   * where a small validation shift is more disruptive than the empty space.
   */
  reserveSpace?: boolean;
}

/**
 * One feedback contract for every form control.
 *
 * Validation errors win over recommendations, which win over static helper
 * copy. With no content the region is not rendered unless a caller explicitly
 * opts into reservation.
 */
export const FormFeedback = ({
  error,
  errorId,
  errorCyTag,
  description,
  helperId,
  recommendation,
  recommendationId,
  recommendationCyTag,
  reserveSpace = false,
}: FormFeedbackProps) => {
  const content = error ? (
    <FieldError id={errorId} cyTag={errorCyTag} message={error} className="mt-0" />
  ) : recommendation ? (
    <FieldRecommendation
      id={recommendationId}
      cyTag={recommendationCyTag}
      message={recommendation}
      className="mt-0"
    />
  ) : description ? (
    <FormHelper id={helperId} text={description} className="mt-0" />
  ) : null;

  if (!content && !reserveSpace) return null;

  return (
    <div
      className={classNames('form-field-feedback flow-root', reserveSpace && 'min-h-4')}
      data-form-feedback
    >
      {content}
    </div>
  );
};
